import { z } from "zod";
import { ROLES } from "../config/roles";

const dropDownSchema = z.object({
  id: z.string(),
  displayText: z.string(),
});
export const schema = z
  .object({
    gpid: z
      .string()
      .nonempty("This field is required")
      .regex(/^\d+$/, "Please enter a valid GPID"),
    firstName: z
      .string()
      .nonempty("This field is required")
      .regex(/^[a-zA-Z\s]+$/, "Please enter a valid first name"),
    lastName: z
      .string()
      .nonempty("This field is required")
      .regex(/^[a-zA-Z\s]+$/, "Please enter a valid last name"),
    email: z
      .string()
      .email("Please enter a valid email")
      .regex(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, "Please enter a valid email"),
    userRoles: z.array(dropDownSchema).nonempty("This field is required"),
    userSectors: z.array(dropDownSchema),
  })
  .refine(
    (data) =>
      !data.userRoles.some((role) =>
        [ROLES.gpLead.displayText, ROLES.stLead.displayText].includes(
          role.displayText
        )
      ) || data.userSectors.length > 0,
    {
      message: "This field is required",
      path: ["userSectors"],
    }
  );
